import React from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import KYC from '../components/KYC'
import Warning from '../components/Warning'
import Banner from "../components/Banner";
const KYCPage = () => {
  return (
    <>
     <section className="hidden lg:block">
      <Banner />
        <Navbar />
      <Warning/>

      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <KYC/>
      <Footer/>

    </>
  )
}

export default KYCPage